import { Box, makeStyles, Typography } from '@material-ui/core'
import React from 'react'

const Staging = () => {

    const classes = useStyles()

    return (
        <Box className={classes.container}>
            <Typography className={classes.env} variant='h6'>Staging</Typography>
        </Box>
    )
}

export default Staging

const useStyles = makeStyles(() => ({
    container: {
        backgroundColor: '#f44336',
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: 40,
    },
    env: {
        color: '#ffffff',
        fontWeight: 'bold'
    }
}))